import { render } from "./Loader.vue?vue&type=template&id=34160b86&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=34160b86&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34160b86"]])

export default __exports__